module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "Create WeChat Channel",
      "width": "40%",
      "visible": _vm.showDialog,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [_c('el-form', {
    ref: "wechatChannelForm",
    attrs: {
      "model": _vm.wechatChannelForm,
      "rules": _vm.wechatChannelFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": "WeChat Name"
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": true
    },
    model: {
      value: (_vm.wechatChannelForm.name),
      callback: function($$v) {
        _vm.$set(_vm.wechatChannelForm, "name", $$v)
      },
      expression: "wechatChannelForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "token",
      "label": "Token"
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": true
    },
    model: {
      value: (_vm.wechatChannelForm.token),
      callback: function($$v) {
        _vm.$set(_vm.wechatChannelForm, "token", $$v)
      },
      expression: "wechatChannelForm.token"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "token_secret",
      "label": "Token Secret"
    }
  }, [_c('el-input', {
    attrs: {
      "autofocus": true
    },
    model: {
      value: (_vm.wechatChannelForm.token_secret),
      callback: function($$v) {
        _vm.$set(_vm.wechatChannelForm, "token_secret", $$v)
      },
      expression: "wechatChannelForm.token_secret"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addingWechatChannel,
      "plain": ""
    },
    on: {
      "click": _vm.handleSaveChannel
    }
  }, [_vm._v("\n      Save\n      "), (_vm.addingWechatChannel) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  }) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f8f634","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/channel/wechat/WechatChannelCreateDialog.vue
// module id = 3349
// module chunks = 3